// import { v4 as uuidv4 } from 'uuid';

export interface AddUpdateRetailer {
    retailerId?: string;
    ownerName?: string;
    shopName: string;
    retailerShopImage: string;
    mobileNumberPrimary: number;
    mobileNumberAlternate?: number;
    location: AddUpdateRetailerLocation;
    isActive: boolean; 
    updatedAt: Date;
    type: string;
}

export interface AddUpdateRetailerLocation {
    country?: string;
    district: string;
    state: string;
    latitude: number;
    longitude: number;
    village: string;    
}

export function toRetailer(form: any): AddUpdateRetailer {
  return {
    retailerId: form.retailerId,
    ownerName: form.retailerName || null,
    shopName: form.shopName,
    retailerShopImage: form.retailerShopImage,
    mobileNumberPrimary: form.mobileNumberPrimary,
    mobileNumberAlternate: form.mobileNumberAlternate || null,
    location: {
      country: form.country || 'KE',
      district: form.district || 'UNKNOWN',
      state: form.state || 'UNKNOWN',
      latitude: form.latitude,
      longitude: form.longitude,
      village: form.village || 'UNKNOWN',
    },
    isActive: form.isActive ?? true,
    updatedAt: form.updatedAt ?? new Date(),
    type: form.type,
  };
}
